import { CheckCircle2, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API, dt } from "@/lib/api";

export const MandateDone = ({ token, info }) => {
  const m = info.mandato;
  const sc = m.signature_check;
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-10 text-center" data-testid="mandate-done-step">
      <CheckCircle2 className="h-16 w-16 mx-auto text-emerald-600" strokeWidth={1.5} />
      <h2 className="font-serif text-3xl sm:text-4xl text-navy mt-4">Mandato ricevuto</h2>
      <p className="text-slate-600 mt-3 max-w-md mx-auto">
        {m.status === "validato" ? "Il mandato è stato validato dallo studio. Ti contatteremo per la raccolta dei documenti." :
          "Grazie. Lo studio verificherà il mandato e ti contatterà per i documenti necessari (documento d'identità, codice fiscale ed eventuale documentazione successoria)."}
      </p>
      <div className="mt-6 inline-grid text-left text-sm gap-1 bg-slate-50 border border-slate-200 rounded-lg p-4">
        <p><span className="text-slate-500">Modalità:</span> <strong data-testid="mandate-done-mode">{m.sign_mode === "digitale" ? "Firma digitale" : "Firma analogica"}</strong></p>
        <p><span className="text-slate-500">Ricevuto il:</span> {dt(m.signed_at)}</p>
        {sc && <p><span className="text-slate-500">Verifica firma:</span> {sc.format} — {sc.message}</p>}
        {sc?.signer && <p className="break-all"><span className="text-slate-500">Firmatario:</span> {sc.signer}</p>}
      </div>
      <div className="mt-6">
        <Button asChild variant="outline" className="rounded-full" data-testid="mandate-done-download-copy">
          <a href={`${API}/public/mandate/${token}/signed`}><Download className="h-4 w-4 mr-2" />Scarica copia del mandato</a>
        </Button>
      </div>
      <p className="text-xs text-slate-500 mt-4">Ti abbiamo inviato una email di conferma con il link alla copia.</p>
    </div>
  );
};
